import { colors } from './helpers';

export const lineSymbol = {
	path: 'M 0,-0.1 0,1',
	strokeOpacity: 1,
	scale: 4
};

export const idaStyles = {
	geodesic: true,
	strokeColor: colors.main,
	strokeOpacity: 0.8,
	strokeWeight: 4
};
export const vueltaStyles = {
	geodesic: true,
	strokeColor: colors.ss,
	strokeOpacity: 0,
	strokeWeight: 4,
	icons: [
		{
			icon: lineSymbol,
			offset: '0',
			repeat: '20px'
		}
	]
};



// WEBPACK FOOTER //
// ./src/utils/polyStyles.js